export default {
  modalWidth: '627px',
};
